__turbopack_context__.v({
  "className": "rubik_e10dbf05-module__V52g5W__className",
  "variable": "rubik_e10dbf05-module__V52g5W__variable",
});
